import { object } from 'common/helpers'


export const initialState = {
  products: [],
}

export const set = (state, payload /* payload = collection */) => payload

export const setProducts = (state, payload /* payload = products */) =>
  object.set(state, 'products', payload)

export const clearProducts = (state) =>
  object.set(state, 'products', [])
